import React, {useState} from 'react';
import {
    IonButton,
    IonTextarea,
    IonFooter
} from '@ionic/react';
import {useTranslation} from "react-i18next";
import isEmpty from "lodash/isEmpty";
import GoogleMapWrapper from "../../../../Components/GoogleMapWrapper";
import WrapperIonModal from '../../../../Components/ionic/WrapperIonModal';

const AddLocationModal = ({isOpen, onClose}) => {
    const {t, i18n} = useTranslation();

    const [message, setMessage] = useState();
    const [location, setLocation] = useState();

    const closeModal = (force = false) => {
        if (location?.lat && !force) {
            let data = {
                lat: `${location.lat}`,
                lng: `${location.lng}`,
                name: message
            };

            onClose && onClose({
                type: "location",
                data
            });
        } else {
            onClose && onClose(false);
        }
        setLocation(undefined);
        setMessage(undefined);
    }


    return <WrapperIonModal
        isOpen={isOpen}
        toggle={() => {
            closeModal(true)
        }}
        title={t('messages.new_message.location_title', "Tap to set location")}>
        <GoogleMapWrapper
            height="calc(100% - 75px)"
            modes={true}
            callback={setLocation}
        />
        <IonFooter mode="ios" className='i-chats-dialogue-footer'>
            <form onSubmit={e => {
                e.preventDefault();
                closeModal();
            }} className="i-chats-dialogue-footer-message">
                <div className="i-chats-dialogue-footer-wrapper">
                    <IonTextarea
                        mode="ios"
                        placeholder={t('messages.new_message.placeholder_text', "Message...")}
                        spellcheck
                        rows={1}
                        autoGrow={message !== ''}
                        onIonChange={(event) => setMessage(event.target.value)}
                        value={message}
                        onKeyDown={(e) => e.keyCode === 13 && closeModal()}
                    />
                </div>
                <IonButton
                    className="i-chats-dialogue-footer-microphone"
                    type="submit"
                    disabled={isEmpty(location)}
                >
                    <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.51 18L21.5 9L0.51 0L0.5 7L15.5 9L0.5 11L0.51 18Z" fill="white"/>
                    </svg>
                </IonButton>
            </form>
        </IonFooter>
    </WrapperIonModal>

    // return (<IonModal ref={modal} isOpen={isOpen} trigger="open-modal" onDidDismiss={(ev) => closeModal()}>
    //         <IonHeader>
    //             <IonToolbar>
    //                 <IonButtons slot="start">
    //                     <IonButton onClick={() => modal.current?.dismiss()}>Cancel</IonButton>
    //                 </IonButtons>
    //                 <IonTitle>Welcome</IonTitle>
    //             </IonToolbar>
    //         </IonHeader>
    //         <IonContent className="ion-padding">
    //             <GoogleMapWrapper
    //                 height="350px"
    //                 modes={true}
    //                 callback={setLocation}
    //             />
    //             <Form className="text-center" onSubmit={closeModal}>
    //                 <InputGroup className='px-2 py-3 py-md-2'>
    //                     <Input
    //                         type="textarea"
    //                         style={{resize: 'none'}}
    //                         placeholder={t('messages.new_message.placeholder_text', "Message...")}
    //                         onChange={(event) => setMessage(event.target.value)}
    //                         value={message}
    //                         onKeyDown={(e) => e.keyCode === 13 && closeModal()}
    //                     />
    //                     <InputGroup addonType="append">
    //                         <Button color="primary" disabled={isEmpty(location)}>
    //                             {t('messages.new_message.button_send_msg', "Send")}
    //                             <br/>
    //                             <span className="opacity-7">
    //                                 (Enter)
    //                             </span>
    //                         </Button>
    //                     </InputGroup>

    //                 </InputGroup></Form>
    //         </IonContent>
    //     </IonModal>
    // );
}

export default AddLocationModal;
